import styled from "styled-components";

const PLAYBOX_URL = "https://www.playbox.com";

const Button = styled.a`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 33px;
  padding: 0 10px;
  border-radius: 100px;
  border: 1px solid rgba(120, 181, 255, 0.62);
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.18) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #3f91ff;
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.07px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  box-shadow:
    0 5px 12px rgba(47, 130, 255, 0.22),
    inset 0 1px 2px rgba(255, 255, 255, 0.2),
    inset 0 -8px 12px -8px rgba(177, 217, 255, 0.32);
  transition:
    filter 0.15s ease,
    transform 0.15s ease;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    filter: brightness(1.08);
  }

  &:active {
    transform: scale(0.97);
  }

  @media (max-width: 375px) {
    height: 28px;
    font-size: 12px;
    padding: 0 8px;
  }
`;

/* Pinned to the pill's top-left corner so the icon + label stay perfectly
   centered (aligned with the Select Image button below) at any width. */
const AdBadge = styled.span`
  position: absolute;
  top: -7px;
  left: 10px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 5px;
  border-radius: 999px;
  background: #0d2d5c;
  border: 1px solid rgba(120, 181, 255, 0.55);
  color: rgba(255, 255, 255, 0.9);
  font-size: 8px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.4px;
`;

const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10V2M8 2L5 5M8 2L11 5M2 11V12.5C2 13.3284 2.67157 14 3.5 14H12.5C13.3284 14 14 13.3284 14 12.5V11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Playbox ad disguised as an upload pill — sits right above the
// "Select Image" button inside the generation modals.
const UploadAdButton = ({ className, style, label = "Upload Image" }) => (
  <Button
    href={PLAYBOX_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`Playbox ad — ${label.toLowerCase()}`}
    className={className}
    style={style}
  >
    <AdBadge>AD</AdBadge>
    <UploadIcon />
    {label}
  </Button>
);

export default UploadAdButton;
